import { Component, inject, input, output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { PageMode } from "../../../constants/enums";
import { IntpCountryValueModel, TableActionEvent, ValueText } from "../../../models";
import { LanguageService } from "../../../services";
import { ConfirmationModalComponent } from "../../general";
import { DataTableComponent } from "../../table/data-table/data-table";
import { IntpCountryValueModalComponent } from "../intp-country-value-modal/intp-country-value-modal";

@Component({
  selector: "adaa-intp-country-values-table",
  imports: [DataTableComponent],
  templateUrl: "./intp-country-values-table.html",
  styleUrl: "./intp-country-values-table.scss",
})
export class IntpCountryValuesTableComponent {
  private readonly _modalService = inject(NgbModal);
  private readonly _languageService = inject(LanguageService);

  tableTitle = input.required<string>();
  inNumbersList = input.required<IntpCountryValueModel[]>();
  valueTypeOptions = input.required<ValueText[]>();
  isDisabled = input<boolean>(false);
  isUaeAndCountry = input<boolean>(false);
  valueChanged = output<IntpCountryValueModel[]>();

  Constants = Constants;

  public get tableData() {
    return AdaaHelper.clone(this.inNumbersList());
  }

  public addNewClicked() {
    const intpCountryValue: IntpCountryValueModel = {
      titleAE: "",
      titleEN: "",
      fakeId: Math.floor(Math.random() * 217 * 1000),
      uaeCountryInNumbers: this.isUaeAndCountry(),
      inNumberValues: [],
      status: Constants.OBJECT_STATUS.ACTIVE,
    };

    this._openEditorModal(intpCountryValue, PageMode.create);
  }

  public actionClicked(event: TableActionEvent) {
    if (event.event === "view") this._openEditorModal(event.data, PageMode.view);
    else if (event.event === "edit") this._openEditorModal(event.data, PageMode.edit);
    else this._openDeleteModal(event.data);
  }

  private _openEditorModal(intpCountryValue: IntpCountryValueModel, pageMode: PageMode) {
    const modal = this._modalService.open(IntpCountryValueModalComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.pageMode.set(pageMode);
    modal.componentInstance.title.set(this.tableTitle());
    modal.componentInstance.isUaeAndCountry.set(this.isUaeAndCountry());
    modal.componentInstance.valueTypeOptions.set(this.valueTypeOptions());
    modal.componentInstance.intpCountryValue.set(intpCountryValue);

    modal.result.then((e) => {
      if (!e) return;
      if (pageMode === PageMode.create) {
        this.inNumbersList().push(e);
      } else {
        const index = this.inNumbersList().findIndex((value) =>
          e.fakeId ? e.fakeId === value.fakeId : e.id === value.id
        );
        if (index > -1) this.inNumbersList().splice(index, 1, e);
      }

      this.valueChanged.emit(this.inNumbersList());
    });
  }

  private _openDeleteModal(intpCountryValue: IntpCountryValueModel) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.header = "international_projects.countries.delete_in_number_value_title";
    modal.componentInstance.title = "international_projects.countries.delete_in_number_value_msg";

    modal.result.then((e) => {
      if (e) this._deleteConfirmed(intpCountryValue);
    });
  }

  private _deleteConfirmed(intpCountryValue: IntpCountryValueModel) {
    const index = this.inNumbersList().findIndex((e) =>
      intpCountryValue.fakeId ? e.fakeId === intpCountryValue.fakeId : e.id === intpCountryValue.id
    );
    if (index > -1) this.inNumbersList().splice(index, 1);

    this.valueChanged.emit(this.inNumbersList());
  }
}
